import envProd from './env.prod.json';

export const erpConfig = {
  apiUrl: envProd.erp?.apiUrl ?? 'https://api.sitikhadijaherp.com/api',
  appKey: envProd.erp?.appkey ?? '',
  appToken: envProd.erp?.apptoken ?? '',
};
